import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CoursesPage.css';
import CoursesList from './CoursesList';

const FEATURES = [
    {
        icon: '🎯',
        title: 'Practical Learning',
        text: 'Strengthen your understanding through hands-on exercises and project-based learning.',
    },
    {
        icon: '💻',
        title: 'Industry-Relevant Skills',
        text: 'Learn modern technologies and tools used in website, software and application development.',
    },
    {
        icon: '👨‍🏫',
        title: 'Guided Learning',
        text: 'Get guidance as you learn concepts, solve problems and build your technical confidence.',
    },
    {
        icon: '🚀',
        title: 'Project-Based Approach',
        text: 'Apply your knowledge by creating projects that help you understand real development workflows.',
    },
];

function CoursesPage() {
    const navigate = useNavigate();

    const goToHome = () => navigate('/');
    const goToWebsite = () => navigate('/home');
    const goToContact = () => navigate('/contact');

    const currentYear = new Date().getFullYear();

    return (
        <main className="courses-page">
            {/* Navbar */}
            <nav className="courses-nav">
                <button
                    type="button"
                    className="courses-back"
                    onClick={goToHome}
                >
                    ← Back to Welcome Page
                </button>

                <button
                    type="button"
                    className="courses-home"
                    onClick={goToWebsite}
                >
                    Visit Website
                </button>
            </nav>

            {/* Hero Section */}
            <section className="courses-hero">
                <span className="courses-badge">NextZen IT Academy</span>

                <h1>
                    Explore Our <span>AI &amp; IT Courses</span>
                </h1>

                <p>
                    Learn in-demand technologies, develop practical skills
                    and prepare yourself for opportunities in the IT industry.
                </p>

                <button
                    type="button"
                    className="courses-cta"
                    onClick={goToContact}
                >
                    Enquire About Courses →
                </button>
            </section>

            {/* Why Choose Section */}
            <section className="why-aptech-section">
                <div className="why-aptech-heading">
                    <span className="why-aptech-label">
                        WHY A.P TECH SOLUTION?
                    </span>

                    <h2>
                        Why Choose <span>NextZen IT Academy?</span>
                    </h2>

                    <p>
                        Build practical skills, work on real-world projects
                        and take the next step toward your IT career.
                    </p>
                </div>

                <div className="why-aptech-grid">
                    {FEATURES.map(({ icon, title, text }) => (
                        <article className="why-aptech-card" key={title}>
                            <div
                                className="why-aptech-icon"
                                aria-hidden="true"
                            >
                                {icon}
                            </div>
                            <h3>{title}</h3>
                            <p>{text}</p>
                        </article>
                    ))}
                </div>
            </section>

            {/* Courses and Syllabus */}
            <CoursesList />

            {/* Bottom CTA */}
            {/* <section className="courses-bottom">
                <h2>Start Your Learning Journey</h2>
                <p>
                    Contact A.P Tech Solutions to learn more about course
                    content, batches and enrollment.
                </p>

                <button type="button" onClick={goToContact}>
                    Contact Us
                </button>
            </section> */}


            <section className="courses-bottom">
                <h2>Start Your Learning Journey</h2>

                <p>
                    Contact A.P Tech Solutions to learn more about course
                    content, batches and enrollment.
                </p>

                <button
                    type="button"
                    onClick={() => {
                        const phone = "919426944526";
                        const message = "Hello A.P Tech Solutions, I want to know more about your courses, course fees, duration, batches and enrollment.";
                        const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

                        window.open(whatsappUrl, "_blank");
                    }}
                >
                    Contact Us
                </button>
            </section>




            {/* Footer */}
            <footer className="courses-footer">
                © {currentYear} A.P Tech Solution. All rights reserved.
            </footer>
        </main>
    );
}

export default CoursesPage;